import { ColumnTypeEnum } from '@y42/json-schema';
import { FormatConfig } from '@y42/model';
import { fieldId } from '../field-id.model';
import { BaseEchartsSettingsModel } from './base-echart-settings.model';
import { MarginModel } from './sub-models/margin.model';

export class StatisticsFieldStoreModel {
  constructor(data: StatisticsFieldStoreModel | null = null) {
    if (data) {
      this.column_id = data.column_id;
      this.column_type = data.column_type;
      this.has_condition = data.has_condition;
      this.conditions = data.conditions;
      this.formula_name = data.formula_name;
      this.format = data.format;
      this.field_id = data.field_id;
      this.formatConfig = data.formatConfig;
    } else {
      this.column_id = '';
      this.has_condition = false;
      this.conditions = [];
      this.formula_name = null;
      this.format = null;
      this.field_id = null;
    }
  }
  column_id: string;
  has_condition: boolean;
  conditions: string[];
  formula_name: string | null;
  format: string | null;
  column_type?: ColumnTypeEnum;
  field_id: fieldId | null;
  formatConfig?: FormatConfig;
}

export enum RegressionTypeEnum {
  ZTransformed = 'z',
  Log = 'l',
  Linear = 'n',
  OneToTen = 's',
}

export class RegressionSettingsModel extends BaseEchartsSettingsModel<never> {
  constructor(data: RegressionSettingsModel | null = null) {
    super([]);
    if (data) {
      this.y = data.y;
      this.y_transformation = data.y_transformation;
      this.x_transformation = data.x_transformation;
      this.x = data.x;
      this.formula_name = data.formula_name;
      this.valid = data.valid;
      if (data.margin) {
        this.margin = data.margin;
      }
    }
  }
  y_transformation: RegressionTypeEnum = RegressionTypeEnum.Linear;
  x_transformation: RegressionTypeEnum = RegressionTypeEnum.Linear;
  formula_name: string[] = [];
  valid = false;
  margin: MarginModel = new MarginModel({
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
  });
  x: StatisticsFieldStoreModel[] = [];
  y: StatisticsFieldStoreModel | null = null;
}

export type RegressionAxis = 'x' | 'y';
